module.exports = __webpack_public_path__ + "img/logo1.7ff549c0.png";